import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

// Layouts
import { DashboardLayout } from '@/components/layout/DashboardLayout';

// Pages
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PatientsPage } from '@/pages/PatientsPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { ProfessionalsPage } from '@/pages/ProfessionalsPage';
import { ServicesPage } from '@/pages/ServicesPage';
import { BoxesPage } from '@/pages/BoxesPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { FinancesPage } from '@/pages/FinancesPage';
import { AgentsPage } from '@/pages/AgentsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/patients" element={<PatientsPage />} />
        <Route path="/professionals" element={<ProfessionalsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/boxes" element={<BoxesPage />} />
        <Route path="/finances" element={<FinancesPage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      <Route path="/" element={<Navigate to="/calendar" replace />} />
      <Route path="*" element={<Navigate to="/calendar" replace />} />
    </Routes>
  );
}
